import { useCallback } from "react";
import bus from "../utils/bus";

/* types => "success" | "error" | "info" | "warning" | "secondary" */
export default function useFlashMessage() {
    const setFlashMessage = useCallback(
        (msgText, msgType, msgTempo = 3, msgPosition = "center") => {
            bus.emit("flash", {
                msgText,
                msgType,
                msgTempo,
                msgPosition,
            });
        },
        [], // ✅ função estável
    );

    return { setFlashMessage };
}
